export default {
  "walletRecord.thead.index": "#NO",
  "walletRecord.thead.userno": "UserNo",
  "walletRecord.thead.email": "Email",
  "walletRecord.thead.balance": "Balance",
  "walletRecord.thead.balanceMin": "balanceMin",
  "walletRecord.thead.balanceMax": "balanceMax",
  "walletRecord.thead.totalDepositAmount": "Total DP",
  "walletRecord.thead.totalDepositMin": "TotalDepositMin",
  "walletRecord.thead.totalDepositMax": "TotalDepositMax",
  "walletRecord.thead.totalWithdrawAmount": "Total WD",
  "walletRecord.thead.totalWithdrawMin": "TotalWithdrawMin",
  "walletRecord.thead.totalWithdrawMax": "TotalWithdrawMax",
  "walletRecord.thead.totalBetAmount": "TotalBetAmt",
  "walletRecord.thead.depositWithdrawDiff": "Asset",
  "walletRecord.thead.channel": "Channel",
  "walletRecord.thead.whatsapp": "Whatsapp",
  "walletRecord.thead.telegram": "Telegram",
  "walletRecord.thead.registerTime": "RegisterTime",
  "walletRecord.thead.lastLoginTime": "LastLoginTime",
  "walletRecord.thead.lastVisitTime": "LastVisitTime",
  "walletRecord.thead.remark": "Remark",
};
